import React, { useState, useEffect } from 'react'
import { Card, CardBody } from 'reactstrap'

import TaskResponsesTable from './partials/TaskResponsesTable'
import ExportTaskResponsesModal from './partials/ExportTaskResponsesModal'
import ListTopBar from '../../components/ListTopBar'

import { getTaskResponses } from './services'
import { handleError, parsePagination } from '../../helpers'

export default function TaskResponsesList() {
	const [taskResponses, setTaskResponses] = useState(null)
	const [pagination, setPagination] = useState({page: 1, per_page: 15, total: 0})
	const [filterType, setFilterType] = useState('user.name')
	const [filterValue, setFilterValue] = useState('')
	const [showExportModal, setShowExportModal] = useState(false)

	useEffect(()=>{
		!taskResponses && getTaskResponses({
			...pagination,
			[`filter[${filterType}]`]: filterValue,
			include: 'taskList,user,tasks.taskTemplate,store'
		})
			.then(res => {
				setTaskResponses(res.data.data)
				setPagination(parsePagination(res))
			})
			.catch(error => handleError(error))
	}, [taskResponses, pagination, filterType, filterValue])

	return (
		<React.Fragment>
			<ListTopBar 
				filterType={filterType}
				setFilterType={setFilterType}
				filterValue={filterValue}
				setFilterValue={setFilterValue}
				reload={() => setTaskResponses(null)}
				title="Listado de Tareas Registradas"
				subtitle="Listados de tareas registradas desde el aplicativo"
				options={[
					{ label: 'Nombre del asesor', value: 'user.name' },
					{ label: 'Nombre del listado', value: 'task_list.name' },
					{ label: 'Fecha de registro (YYYY-MM-DD)', value: 'created_at' },
				]}
				onExport={() => setShowExportModal(true)}
			/>
			<Card>
				<CardBody>
					<TaskResponsesTable 
						taskResponses={taskResponses} 
						reload={()=>setTaskResponses(null)}
						pagination={pagination}
						setPagination={setPagination}
					/>
				</CardBody>
			</Card>
			{ showExportModal && (
				<ExportTaskResponsesModal 
					visible
					onClose={() => setShowExportModal(false)}
				/>
			)}
		</React.Fragment>
	)
}